// /project-root/react-app/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app.js';
import { WebSocketProvider } from './connections/WebSocketContext.js';

// Initialize React app
console.log('React: Initializing application');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WebSocketProvider>
      <App />
    </WebSocketProvider>
  </React.StrictMode>
);

// Log successful initialization
console.log('React: Application mounted successfully');

// Add global error handler for debugging
window.addEventListener('error', (event) => {
  console.error('React: Global error caught:', event.error);
});

// Add unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('React: Unhandled promise rejection:', event.reason);
});

// Expose React version for debugging
console.log('React: Version', React.version);